import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import "../App.css";

const Borsa = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentDay, setCurrentDay] = useState("");
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);

  // متوسط السعر المرجعي (مخفي عن المستخدم)
  const AVERAGE_PRICE = 2800;

  // المحافظات الأساسية
  const governoratesList = [
    "سامراء",
    "ميسان",
    "النجف",
    "كربلاء",
    "السماوة",
    "الموصل",
    "ديالى",
    "الناصرية",
    "البصرة",
    "الديوانية",
    "الانبار",
    "بابل",
    "واسط",
    "بغداد",
    "صلاح الدين",
    "كركوك",
    "المناطق الجنوبية",
    "المناطق الشمالية",
    "الاقليم",
  ];

  // تحديث التاريخ واليوم
  useEffect(() => {
    updateDate();
  }, []);

  // جلب البيانات من Firebase
  useEffect(() => {
    const pricesRef = ref(db, "prices");

    const unsubscribe = onValue(pricesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // تحويل البيانات من object إلى array
        const pricesArray = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setPrices(pricesArray);
      } else {
        // إذا لا توجد بيانات، استخدم الافتراضية
        const defaultPrices = governoratesList.map((gov, index) => ({
          id: `default-${index}`,
          governorate: gov,
          price: "2500",
          timestamp: new Date().toISOString(),
        }));
        setPrices(defaultPrices);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const updateDate = () => {
    const now = new Date();
    const days = [
      "الأحد",
      "الإثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت",
    ];
    const dayName = days[now.getDay()];
    const formattedDate = `${now.getDate()}/${
      now.getMonth() + 1
    }/${now.getFullYear()}`;

    setCurrentDay(dayName);
    setCurrentDate(formattedDate);
  };

  // حساب النسبة المئوية للتغير تلقائياً
  const calculatePercentageChange = (price) => {
    const change = ((parseInt(price) - AVERAGE_PRICE) / AVERAGE_PRICE) * 100;
    return change.toFixed(1);
  };

  // تحديد إذا كان السعر أعلى من المتوسط
  const isPriceAboveAverage = (price) => {
    return parseInt(price) > AVERAGE_PRICE;
  };

  // تحديد لون السعر بناءً على قيمته
  const getPriceColor = (price) => {
    return isPriceAboveAverage(price) ? "#059669" : "#dc2626";
  };

  // تحديد لون الخلفية للبطاقة
  const getCardBackground = (price) => {
    return isPriceAboveAverage(price)
      ? "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)"
      : "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)";
  };

  if (loading) {
    return (
      <div className="app">
        <header className="header compact-header">
          <div className="container">
            <div className="header-content compact-header-content">
              <div className="logo-section compact-logo">
                <div className="logo">🐔</div>
                <div className="title-section compact-title">
                  <h1 className="title compact-title-text">
                    بورصة الدجاج العراقية
                  </h1>
                  <p className="subtitle compact-subtitle">أسعار يومية محدثة</p>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="main compact-main">
          <div className="container">
            <div className="loading">جاري تحميل البيانات...</div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      {/* الهيدر المدمج */}
      <header className="header compact-header">
        <div className="container">
          <div className="header-content compact-header-content">
            <div className="logo-section compact-logo">
              <div className="logo">🐔</div>
              <div className="title-section compact-title">
                <h1 className="title compact-title-text">
                  بورصة الدجاج العراقية
                </h1>
                <p className="subtitle compact-subtitle">أسعار يومية محدثة</p>
              </div>
            </div>
            <div className="header-right compact-header-right">
              <div className="admin-link">
                <a
                  href="/?admin=true"
                  className="admin-icon"
                  title="لوحة الإدارة"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/?admin=true";
                  }}
                >
                  ⚙️
                </a>
              </div>
              <div className="date-info compact-date">
                <div className="date-badge compact-date-badge">
                  <div className="highlight compact-highlight">
                    {currentDay} - {currentDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* المحتوى الرئيسي */}
      <main className="main compact-main">
        <div className="container">
          <div className="prices-section compact-prices">
            <div className="section-header compact-section-header">
              <h2 className="section-title compact-section-title">
                📊 أسعار الدجاج الحي
              </h2>
              <div className="price-unit compact-price-unit">
                (دينار عراقي/كغم)
              </div>
            </div>

            <div className="prices-grid compact-prices-grid">
              {prices.map((item) => {
                const percentageChange = calculatePercentageChange(item.price);
                const isAbove = isPriceAboveAverage(item.price);

                return (
                  <div
                    key={item.id}
                    className="price-card compact-price-card"
                    style={{
                      background: getCardBackground(item.price),
                    }}
                  >
                    <div className="card-header compact-card-header">
                      <div className="governorate-section compact-governorate">
                        <div className="gov-badge compact-gov-badge">
                          {item.governorate}
                        </div>
                        <div
                          className={`trend-indicator compact-trend ${
                            isAbove ? "up" : "down"
                          }`}
                        >
                          {isAbove ? "↗" : "↘"}
                        </div>
                      </div>
                    </div>

                    <div className="price-content compact-price-content">
                      <div className="price-main compact-price-main">
                        <div
                          className="price compact-price"
                          style={{ color: getPriceColor(item.price) }}
                        >
                          {parseInt(item.price).toLocaleString()}
                        </div>
                        <div className="currency compact-currency">دينار</div>
                      </div>

                      <div className="change-info compact-change-info">
                        <div
                          className="change-percentage compact-change-percent"
                          style={{ color: getPriceColor(item.price) }}
                        >
                          {isAbove ? "+" : ""}
                          {percentageChange}%
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </main>

      {/* الفوتر المدمج */}
      <footer className="footer compact-footer">
        <div className="container">
          <div className="footer-content compact-footer-content">
            <div className="footer-info compact-footer-info">
              <p className="copyright compact-copyright">
                &copy; {new Date().getFullYear()} بورصة الدجاج العراقية
              </p>
              <p className="designer compact-designer">
                تصميم المهندس بركات طايس السلماني
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Borsa;
